<template>
    <div>
        <table-tool-bar>
            <template slot="left">
                <table-searcher
                    v-model="filter.keyword"
                    placeholder="请输入管家姓名"
                    style="margin-left: 10px"
                    @search="search"
                ></table-searcher>
            </template>
            <Button
                v-if="$can('add')"
                :class="preCls + 'button-margin'"
                :disabled="loading"
                type="primary"
                @click="onClickAdd"
            >
                新增
            </Button>
        </table-tool-bar>
        <Table
            ref="mt"
            :columns="columns"
            :data="page.list"
            :loading="loading"
            :height="mtHeight"
        >
            <template v-slot:billStatusText="{ row }">
                <tag-status
                    v-if="row.overdue === 0"
                    :text="row.billStatusText"
                    :color="row.billStatusColor"
                    :background="row.billStatusBgc"
                    circle
                />
                <tag-status
                    v-else
                    :text="`逾期${row.overdue}天`"
                    color="#EE870D"
                    background="#F9F2E9"
                    circle
                />
            </template>
            <!-- 操作列 -->
            <template v-slot:action="{ row }">
                <Button
                    v-if="$can('view')"
                    type="default"
                    size="small"
                    style="margin-right: 5px"
                    @click="rowClickView(row)"
                >
                    详情
                </Button>
                <Button
                    v-if="$can('update')"
                    type="default"
                    size="small"
                    style="margin-right: 5px"
                    @click="rowClickUpdate(row)"
                >
                    修改
                </Button>
                <PoptipButton
                    v-if="$can('delete')"
                    text="删除"
                    transfer
                    placement="top-end"
                    type="default"
                    title="您确定删除这条记录吗？"
                    :ok="() => rowClickDelete(row)"
                />
            </template>
        </Table>
        <!-- 底部分页 -->
        <table-pager
            :total.sync="page.total"
            :pageSize.sync="filter.pageSize"
            :pageNo.sync="filter.pageNo"
            @change="fetch"
        ></table-pager>
        <!-- 弹出层 -->
        <smart-modal
            v-model="modal.showManageForm"
            :title="actionTitle + '管家'"
            :width="800"
            :height="500"
            :maskClosable="false"
            @close-by-confirm="fetch"
        >
            <m-manage-form
                v-if="modal.showManageForm"
                :id="curId"
                :actionType="actionType"
            />
        </smart-modal>
    </div>
</template>

<script>
import { mapCache } from '@/plugins/vux-data-cache'

import { shopManageList, shopManageDelete } from '@/api/shop'
import { ymdL } from '@/utils/helper'

import MManageForm from './m-manage-form'

export default {
    data() {
        return {
            mtHeight: 360,
            loading: false,
            curId: '',
            actionType: '', // 1 新增; 2 查看; 3 修改;
            page: {
                total: 0,
                list: [],
            },
            modal: {
                showManageForm: false,
            },
            dict: {
                actionType: this.$dict.NULL,
            },
        }
    },

    components: { MManageForm },

    computed: {
        ...mapCache({
            filter: 'manageInfo',
        }),
        actionTitle() {
            if (this.dict.actionType) {
                return this.dict.actionType.val(this.actionType)
            }
            return ''
        },
        columns() {
            return [
                {
                    type: 'index',
                    title: '序号',
                    align: 'center',
                    minWidth: 60,
                },
                {
                    key: 'nickname',
                    title: '管家姓名',
                    align: 'left',
                    minWidth: 100,
                    tooltip: true,
                },
                {
                    key: 'phone',
                    title: '管家手机号',
                    align: 'center',
                    minWidth: 120,
                },
                {
                    key: 'floorName',
                    title: '负责楼栋',
                    align: 'left',
                    minWidth: 160,
                    tooltip: true,
                },
                {
                    key: 'shopName',
                    title: '工作店面',
                    align: 'left',
                    minWidth: 130,
                    tooltip: true,
                },
                {
                    key: 'tel',
                    title: '店面电话',
                    align: 'left',
                    minWidth: 130,
                    tooltip: true,
                },
                {
                    key: 'addr',
                    title: '店面地址',
                    align: 'left',
                    minWidth: 160,
                    tooltip: true
                },
                {
                    key: 'createTime',
                    title: '创建时间',
                    align: 'center',
                    minWidth: 150,
                },
                {
                    title: '操作',
                    align: 'center',
                    width: 180,
                    slot: 'action',
                    fixed: 'right',
                },
            ]
        },
    },

    created() {
        this.fetch()
    },

    mounted() {
        this.afterContainerResize((el, detector) => {
            this.mtHeight =
                detector.windowHeight -
                this.$refs.mt.$el.getBoundingClientRect().top -
                80
        })
    },

    methods: {
        fetch() {
            this.loading = true
            Promise.all([
                shopManageList(this.filter),
                this.$dict.get(['action_type']),
            ])
                .then((args) => {
                    const [res, group] = args
                    Object.assign(this.dict, group)
                    this.setPageData(res.data)
                })
                .finally(() => {
                    this.loading = false
                })
        },
        search() {
            this.filter.pageNo = 1
            this.fetch()
        },

        setPageData(data) {
            data.page.list.forEach((v) => {
                v.createTime = ymdL(v.createTime)
            })
            this.page.list = data.page.list
            this.page.total = parseInt(data.page.totalCount)
        },
        // 新增
        onClickAdd(e) {
            this.actionType = '1'
            this.curId = ''
            this.modal.showManageForm = true
        },
        // 详情
        rowClickView(row) {
            this.actionType = '2'
            this.curId = row.id
            this.modal.showManageForm = true
        },

        // 修改
        rowClickUpdate(row) {
            this.actionType = '3'
            this.curId = row.id
            this.modal.showManageForm = true
        },
        // 删除
        rowClickDelete(row) {
            shopManageDelete(row.id).then(() => {
                this.$Message.success(this.$t('tips.delete.success'))
                this.fetch()
            })
        },
    },
}
</script>
<style lang="less" scoped></style>
